var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
export function SomethingWentWrong() {
    return (_jsxs("main", __assign({ className: "items-center py-20 flex flex-col" }, { children: [_jsx(Typography, __assign({ variant: "h2", className: "text-3xl" }, { children: "Something went wrong" })), _jsx(Typography, __assign({ variant: "p" }, { children: "An unexpected error occurred. Please try again later." }))] })));
}
